import 'swiper/css'
import 'swiper/css/navigation'

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

class SwiperMain {
  constructor(slider, breakpoint, customOptions = {}) {
    this.elements = {
      slider,
			nextEl: slider.querySelector('.swiper-button-next'),
			prevEl: slider.querySelector('.swiper-button-prev'),
    }
		this.breakpoint = breakpoint
		this.customOptions = customOptions
    this.init()
	}


  defineSlider() {
    this.slider = new Swiper(this.elements.slider, {
      modules: [ Navigation ],
      spaceBetween: 15,
			autoHeight: true,
			navigation: {
				nextEl: this.elements.nextEl,
				prevEl: this.elements.prevEl,
			},
			...this.customOptions
		})
  }

	toggleSlider(event) {
    if (event) {
      if (event.matches) {
        if (this.slider) {
          this.slider.destroy()
          this.slider = null
        }
      } else {
        this.defineSlider()
      }
    } else {
      if (window.innerWidth < this.breakpoint) {
        this.defineSlider()
      }
    }
  }

  init() {
    this.toggleSlider()

    const media = `(min-width: ${this.breakpoint}px)`
    const mediaWatcher = window.matchMedia(media)
    mediaWatcher.addEventListener('change', this.toggleSlider.bind(this))
  }
}
const benefitsSliderEl = document.querySelector('.benefits-slider')
if (benefitsSliderEl) {
  new SwiperMain(benefitsSliderEl, 667)
}

const blogListEl = document.querySelector('.posts-list.swiper')
if (blogListEl) {
	new SwiperMain(blogListEl, 1100, {
		breakpoints: {
			700: {
				slidesPerView: 2,
				spaceBetween: 30
			},
			320: {
				slidesPerView: 1,
				spaceBetween: 30
			}
		}
	})
}

const helpListEl = document.querySelector('.help-list__list')
if (helpListEl) {
  new SwiperMain(helpListEl, 667)
}
